import * as React from 'react';
export const subscriptionSvg = React.forwardRef(function subscriptionSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.9 7.8V5h8.2v1.75a1.3 1.3 0 0 1-1.3 1.3H6.517l1.316-1.466a.65.65 0 1 0-.967-.868l-2.335 2.6a.65.65 0 0 0 0 .868l2.335 2.6a.65.65 0 0 0 .967-.868L6.517 9.45H8.8a2.7 2.7 0 0 0 2.7-2.7V3.2A2.7 2.7 0 0 0 8.8.5H3.2A2.7 2.7 0 0 0 .5 3.2v4.6a2.7 2.7 0 0 0 2.7 2.7h.1a.7.7 0 1 0 0-1.4h-.1a1.3 1.3 0 0 1-1.3-1.3Zm1.3-5.9a1.3 1.3 0 0 0-1.3 1.3v.5h8.2v-.5a1.3 1.3 0 0 0-1.3-1.3H3.2Z',
    }),
  );
});
subscriptionSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var subscription = {
  category: 'icon',
  colorable: true,
  name: 'subscription',
  svg: subscriptionSvg,
};
